/**
 * @Project Name: vue-admin
 * @Author: luichooy
 * @Date: 2018-01-17 15:01
 * @Email: luichooy@163.com
 * @Idea: WebStorm
 */

import Layout from 'src/pages/layout/layout';

// 不作为main组件子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录'
    },
    component: () => import('src/pages/login/login')
};

// 错误页面
export const errorRouter = {
    path: '/error/:code',
    name: 'error',
    meta: {
        title: 'error'
    },
    component: () =>
        import('src/pages/error/index')
};

// 作为main组件子页面展示  但不在左侧菜单显示的路由卸载otherRoter里
export const otherRouter = {
    path: '',
    name: 'otherRouter',
    redirect: '/login',
    meta: {
        requireAuth: true
    },
    component: Layout,
    children: [
        {
            path: 'home',
            name: 'home',
            title: '首页',
            component: () => import('src/pages/home/home')
        }
    ]
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
    {
        path: '/tables',
        name: 'tables',
        title: '表格管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'basic',
                name: 'basic',
                title: '基本表格',
                component: () => import('src/pages/tables/basic')
            },
            {
                path: 'sort',
                name: 'sort',
                title: '排序表格',
                component: () => import('src/pages/tables/sort')
            },
            {
                path: 'filter',
                name: 'filter',
                title: '筛选表格',
                component: () => import('src/pages/tables/filter')
            }
        ]
    },
    {
        path: '/charts',
        name: 'charts',
        title: 'echarts图表',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'bar',
                name: 'bar',
                title: '柱状图',
                component: () => import('src/pages/charts/bar')
            },
            {
                path: 'line',
                name: 'line',
                title: '折线图',
                component: () => import('src/pages/charts/line')
            },
            {
                path: 'pie',
                name: 'pie',
                title: '饼图',
                component: () => import('src/pages/charts/pie')
            }
        ]
    },
    {
        path: '/form',
        name: 'form',
        title: '表单管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'render',
                name: 'render',
                title: '渲染表单',
                component: () => import('src/pages/form/render/render')
            }
        ]
    },
    {
        path: '/match1',
        name: 'match',
        title: '赛事管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'match_index',
                title: '赛事',
                component: () => import('src/pages/match1/index/index')
            },
            {
                path: 'manage',
                name: 'match_manage',
                title: '管理',
                component: () => import('src/pages/match1/manage/index')
            },
            {
                path: 'create_match',
                name: 'match_create_match',
                title: '创建赛事',
                component: () => import('src/pages/match1/createMatch/index')
            },
            {
                path: 'edit_match',
                name: 'match_edit_match',
                title: '创建赛事',
                component: () => import('src/pages/match1/editMatch/index')
            },
            {
                path: 'create_race',
                name: 'match_create_race',
                title: '创建比赛',
                component: () => import('src/pages/match1/createRace/index')
            },
            {
                path: 'edit_race',
                name: 'match_edit_race',
                title: '编辑比赛',
                component: () => import('src/pages/match1/editRace/index')
            },
            {
                path: 'group_enroll',
                name: 'match_group_enroll',
                title: '组别报名',
                component: () => import('src/pages/match1/groupEnroll/index')
            },
            {
                path: 'organization_enroll',
                name: 'match_organization_enroll',
                title: '单位报名',
                component: () => import('src/pages/match1/organizationEnroll/index')
            }
        ]
    },
    {
        path: '/statistics',
        name: 'statistics',
        title: '数据统计',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'statistics_index',
                title: '数据统计',
                component: () => import('src/pages/statistics/index')
            },
            {
                path: 'detail',
                name: 'statistics_detail',
                title: '个人统计',
                component: () => import('src/pages/statistics/detail')
            }
        ]
    },
    {
        path: '/account1',
        name: 'account',
        title: '帐号管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'account_index',
                title: '帐号管理',
                component: () => import('src/pages/account1/index')
            }
        ]
    },
    {
        path: '/team',
        name: 'team',
        title: '球队管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'team_index',
                title: '球队管理',
                component: () => import('src/pages/team/index')
            }
        ]
    },
    {
        path: '/test',
        name: 'test',
        title: '测试',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'test_index',
                title: '测试',
                component: () => import('src/pages/test/test')
            }
        ]
    },


    {
        path: '/overview',
        name: 'overview',
        title: '概览',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'overview_index',
                title: '概览',
                component: () => import('src/pages/overview/index/index')
            }
        ]
    },
    {
        path: '/school',
        name: 'school',
        title: '学校管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'school_index',
                title: '学校管理',
                component: () => import('src/pages/school/index/index')
            },
            {
                path: 'add',
                name: 'school_add',
                title: '添加学校',
                component: () => import('src/pages/school/add/add')
            },
            {
                path: 'edit',
                name: 'school_edit',
                title: '编辑学校',
                component: () => import('src/pages/school/edit/edit')
            }

        ]
    },
    {
        path: '/student',
        name: 'student',
        title: '学生管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'student_index',
                title: '学生管理',
                component: () => import('src/pages/student/index/index')
            },
            {
                path: 'edit',
                name: 'student_edit',
                title: '编辑学生',
                component: () => import('src/pages/student/edit/edit')
            }
        ]
    },
    {
        path: '/match',
        name: 'match',
        title: '赛事管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'match_index',
                title: '赛事管理',
                component: () => import('src/pages/match/index/index')
            },
            {
                path: 'create',
                name: 'match_create',
                title: '预选赛',
                component: () => import('src/pages/match/create/create')
            },
            {
                path: 'manage',
                name: 'match_manage',
                title: '预选赛',
                component: () => import('src/pages/match/manage/index')
            }
            // {
            //     path: 'create',
            //     name: 'match_create',
            //     title: '官方赛',
            //     component: () => import('src/pages/match/create/create')
            // }
        ]
    },
    {
        path: '/account',
        name: 'account',
        title: '账号管理',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'account_index',
                title: '账号管理',
                component: () => import('src/pages/account/index/index')
            },
            {
                path: 'add',
                name: 'account_add',
                title: '账号添加',
                component: () => import('src/pages/account/add/add')
            },
            {
                path: 'edit',
                name: 'account_edit',
                title: '账号编辑',
                component: () => import('src/pages/account/edit/edit')
            },
            {
                path: 'manage',
                name: 'account_manage',
                title: '账号管理',
                component: () => import('src/pages/account/manage/manage')
            }
        ]
    },
    {
        path: '/apply',
        name: 'apply',
        title: '开户申请',
        meta: {
            requireAuth: true
        },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'apply_index',
                title: '开户申请',
                component: () => import('src/pages/apply/index/index')
            }
        ]
    }

];

export const routers = [
    errorRouter,
    loginRouter,
    otherRouter,
    ...appRouter
];



// WEBPACK FOOTER //
// ./src/router/route.js